import { dateTimeFormat, uuidv4 } from '@/utility/utility_functions'

export default class File {
  constructor (uuid, url, deleteUrl, name, updated) {
    this.uuid = uuid
    this.url = url
    this.deleteUrl = deleteUrl
    this.name = name
    this.updated = updated
  }

  static asFiles (json) {
    return json.map(jsonItem => {
      return File.asFile(jsonItem)
    })
  }

  static asFile (json) {
    return new File(
      uuidv4(),
      json.url,
      json.delete_url,
      json.name,
      json.updated_at ? dateTimeFormat(json.updated_at) : ''
    )
  }
}
